<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-12 15:36:17
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-07-04 14:18:24
 * @FilePath: /jy-dashboard-web/src/components/companyProfile/map-dtfb.vue
 * @Description: 地图-分布
-->
<template>
  <div class="dtfb" id="map"></div>
  <div id="popup" class="ol-popup" v-show="showPopup">
    <span class="title">{{ feature.jdmc }}</span>
    <section class="data">
      <span class="name">茶园面积:</span>
      <span class="value">{{ feature.jdmj || "- 亩" }}</span>
    </section>
  </div>
</template>

<script>
import 'ol/ol.css'
import Map from 'ol/Map'
import View from 'ol/View'
import Overlay from 'ol/Overlay'
import MapboxVector from 'ol/layer/MapboxVector'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import Point from 'ol/geom/Point'
import Feature from 'ol/Feature'
import { Icon, Style } from 'ol/style'
import { fromLonLat } from 'ol/proj'
import { mapActions, mapState } from 'vuex'
export default {
  data () {
    return {
      map: '',
      overlay: '',
      view: '',
      showPopup: false,
      feature: {},
      index: 0
    }
  },
  watch: {
    dtfb () {
      this.initMap()
    }
  },
  computed: {
    ...mapState('company-profile', ['dtfb', 'loading'])
  },
  methods: {
    ...mapActions('company-profile', ['getDTFB']),
    initMap () {
      document.getElementById('map').innerHTML = ''
      this.overlay = new Overlay({
        element: document.getElementById('popup'),
        autoPan: {
          animation: {
            duration: 250
          }
        },
        insertFirst: true
      })

      const iconFeatures = []
      let iconFeature = ''
      this.dtfb.map((item) => {
        iconFeature = new Feature({
          geometry: new Point(fromLonLat(item.lat_lng)),
          jdmc: item.jdmc,
          jdbh: item.jdbh,
          jdlb: item.jdlb,
          jdmj: item.jdmj
        })
        iconFeature.setStyle(new Style({
          image: new Icon({
            imgSize: [31, 31],
            src: `image/company-profile/map/${item.jdlb}@2x.png`
          })
        }))
        iconFeatures.push(iconFeature)
        return item
      })

      const vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: iconFeatures
        })
      })

      this.view = new View({
        center: fromLonLat([110, 29]),
        zoom: 5.5,
        minZoom: 5.5,
        maxZoom: 5.5,
        rotation: 0
      })

      this.map = new Map({
        target: 'map',
        layers: [
          new MapboxVector({
            styleUrl: 'mapbox://styles/wupeiwen/cl4ffik80000115p7polssm80',
            accessToken: 'pk.eyJ1Ijoid3VwZWl3ZW4iLCJhIjoiY2o1eGFvNmQ2MDE5ejMydGJnYWl5dW05ZiJ9.LZMds8C2elQe8UTPm2YAJA'
          }),
          vectorLayer
        ],
        view: this.view,
        overlays: [this.overlay]
      })

      const loopFeature = async (features, that) => {
        while (true) {
          await new Promise((resolve) => setTimeout(resolve, 5000))
          that.showPopup = true
          that.view.setCenter(iconFeatures[that.index].values_.geometry.flatCoordinates)
          that.feature = iconFeatures[that.index].values_
          that.overlay.setPosition(iconFeatures[that.index].values_.geometry.flatCoordinates)
          if (that.index === iconFeatures.length - 1) {
            that.index = 0
          } else {
            that.index = that.index + 1
          }
        }
      }
      loopFeature(iconFeatures, this)
      // this.map.on('singleclick', (event) => {
      //   const feature = this.map.forEachFeatureAtPixel(event.pixel, (feature, layer) => {
      //     return feature
      //   })
      //   if (feature) {
      //     this.feature = feature.values_
      //     this.overlay.setPosition(event.coordinate)
      //     this.showPopup = true
      //   }
      // })
    }
  },
  mounted () {
    this.getDTFB()
  },
  beforeUnmount () {

  }
}
</script>

<style lang="scss">
.ol-popup {
  position: absolute;
  bottom: 15px;
  left: -153px;
  width: 306px;
  height: 149px;
  background-image: url("/public/image/company-profile/bg/地图弹窗@2x.png");
  // z-index: 1000;
  .title {
    font-size: 20px;
    line-height: 22px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #ffffff;
    position: absolute;
    top: 26px;
    left: 22px;
    width: 168px;
  }
  .data {
    position: absolute;
    bottom: 37px;
    left: 22px;
    .name {
      display: inline-block;
      vertical-align: top;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      opacity: 0.54;
      margin-right: 20px;
    }
    .value {
      display: inline-block;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
</style>
